var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"centered"},[_c('NewPost',{attrs:{"feed_key":"main"},on:{"add_post":_vm.add_post}})],1),_c('div',{staticClass:"centered"},[_c('Feed',{ref:"feed",attrs:{"feed_key":"main"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }